import Column from "./column";
var Form = /** @class */ (function () {
    function Form(el) {
        this.form = el;
        this.$form = jQuery(el);
        this.$column_container = this.$form.find('.ac-columns');
        this.$container = jQuery('#cpac .ac-admin');
        this.columns = {};
        this._validators = [];
        jQuery(document).trigger('AC_Form_Loaded');
    }
    Form.prototype.init = function () {
        this.initColumns();
        this.bindFormEvents();
        this.bindOrdering();
        if (this.$form.hasClass('-disabled')) {
            this.disableFields();
        }
        jQuery(document).trigger('AC_Form_Ready', this);
    };
    Form.prototype.bindOrdering = function () {
        if (this.$form.hasClass('ui-sortable')) {
            this.$form.sortable('refresh');
        }
        else {
            this.$form.sortable({
                items: '.ac-column',
                handle: '.column_sort'
            });
        }
    };
    Form.prototype.originalColumns = function () {
        var self = this;
        var columns = [];
        Object.keys(self.columns).forEach(function (key) {
            var column = self.columns[key];
            if (column.isOriginal()) {
                columns.push(column.type);
            }
        });
        return columns;
    };
    Form.prototype.validateForm = function () {
        var _this = this;
        var valid = true;
        this._validators.forEach(function (validator) {
            valid = validator.call(_this, _this);
        });
        return valid;
    };
    Form.prototype.addValidator = function (validator) {
        this._validators.push(validator);
    };
    Form.prototype.bindFormEvents = function () {
        var self = this;
        var $buttons = jQuery('.sidebox a.submit, .column-footer a.submit');
        $buttons.on('click', function () {
            if (!self.validateForm()) {
                return;
            }
            $buttons.attr('disabled', 'disabled');
            self.$container.addClass('saving');
            self.submitForm().always(function () {
                $buttons.removeAttr('disabled', 'disabled');
                self.$container.removeClass('saving');
            });
        });
        self.$container.find('.add_column').on('click', function () {
            self.addColumn();
        });
        var $boxes = jQuery('#cpac .ac-boxes');
        if ($boxes.hasClass('disabled')) {
            $boxes.find('.ac-column').each(function (i, col) {
                jQuery(col).data('column').disable();
                jQuery(col).find('input, select').prop('disabled', true);
            });
        }
        jQuery('a[data-clear-columns]').on('click', function () {
            self.resetColumns();
        });
    };
    Form.prototype.initColumns = function () {
        var self = this;
        self.columns = {};
        this.$form.find('.ac-column').each(function () {
            var $el = jQuery(this);
            var column = new Column($el);
            column.bindEvents();
            $el.data('column', column);
            self.columns[column.name] = column;
        });
    };
    Form.prototype.reindexColumns = function () {
        var self = this;
        self.columns = {};
        this.$form.find('.ac-column').each(function () {
            var column = jQuery(this).data('column');
            self.columns[column.name] = column;
        });
    };
    Form.prototype.resetColumns = function () {
        var _this = this;
        Object.keys(this.columns).forEach(function (key) {
            var column = _this.columns[key];
            column.destroy();
        });
    };
    Form.prototype.serialize = function () {
        return this.$form.serialize();
    };
    Form.prototype.disableFields = function () {
        var form = document.querySelector(this.form);
        if (!form) {
            return;
        }
        var elements = form.elements;
        for (var i = 0; i < elements.length; i++) {
            elements[i].readOnly = true;
            elements[i].setAttribute('disabled', true);
        }
    };
    Form.prototype.enableFields = function () {
    };
    Form.prototype.submitForm = function () {
        var self = this;
        var xhr = jQuery.post(ajaxurl, {
            action: 'ac-columns',
            id: 'save',
            _ajax_nonce: AC._ajax_nonce,
            data: this.serialize(),
        }, function (response) {
            if (response) {
                if (response.success) {
                    self.showMessage(response.data, 'updated');
                    self.$container.addClass('stored');
                }
                // Error message
                else if (response.data) {
                    self.showMessage(response.data.message, 'notice notice-warning');
                }
            }
        }, 'json');
        // No JSON
        xhr.fail(function (error) {
            self.showMessage(AC.i18n.errors.save_settings, 'notice notice-warning');
        });
        jQuery(document).trigger('AC_Form_AfterUpdate', [self.$container]);
        return xhr;
    };
    Form.prototype.showMessage = function (message, attr_class) {
        if (attr_class === void 0) { attr_class = 'updated'; }
        var $msg = jQuery('<div class="ac-message hidden ' + attr_class + '"><p>' + message + '</p></div>');
        this.$container.find('.ac-message').stop().remove();
        this.$container.find('.ac-admin__main').prepend($msg);
        $msg.slideDown();
    };
    Form.prototype.cloneColumn = function ($el) {
        return this._addColumnToForm(new Column($el).clone(), $el.hasClass('opened'), $el);
    };
    Form.prototype.addColumn = function () {
        var $clone = jQuery('#add-new-column-template').find('.ac-column').clone();
        var column = new Column($clone).create();
        return this._addColumnToForm(column);
    };
    Form.prototype.removeColumn = function (name) {
        if (this.columns[name]) {
            this.columns[name].remove();
            delete this.columns[name];
        }
    };
    Form.prototype.getListScreen = function () {
        return this.$form.find('input[name="list_screen"]').val();
    };
    Form.prototype.getListScreenID = function () {
        return this.$form.find('input[name="list_screen_id"]').val();
    };
    Form.prototype.getTitle = function () {
        return this.$form.find('input[name="title"]').val();
    };
    Form.prototype.getColumnSettings = function () {
        return this.$form.find('[name^="columns["]').serialize();
    };
    Form.prototype._addColumnToForm = function (column, open, $after) {
        if (open === void 0) { open = true; }
        if ($after === void 0) { $after = null; }
        this.columns[column.name] = column;
        if ($after) {
            column.$el.insertAfter($after);
        }
        else {
            this.$column_container.append(column.$el);
        }
        if (open) {
            column.open();
        }
        column.$el.hide().slideDown();
        jQuery(document).trigger('AC_Column_Added', [column]);
        if (!isInViewport(column.$el)) {
            jQuery('html, body').animate({ scrollTop: column.$el.offset().top - 58 }, 300);
        }
        return column;
    };
    return Form;
}());
export default Form;
var isInViewport = function ($el) {
    var elementTop = $el.offset().top;
    var elementBottom = elementTop + $el.outerHeight();
    var viewportTop = jQuery(window).scrollTop();
    var viewportBottom = viewportTop + jQuery(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};
